import { render } from "./BootstrapTabs.vue?vue&type=template&id=3ac7178d"
import script from "./BootstrapTabs.vue?vue&type=script&lang=js"
export * from "./BootstrapTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__